@if (card; as staffOrderCard) {
  <article class="ots-staff-order d-flex flex-direction-column gap-16 full-width overflow-hidden c-bg-gray-100 medium-border-radius p-y-16">
    <div class="ots-staff-order__head d-flex flex-direction-column gap-8 align-items-start p-x-16">
      <span
        class="ots-staff-chip d-inline-flex align-items-center width-fit-content white-space-nowrap gap-4 p-y-4 p-x-8"
        [class.ots-staff-chip--new]="staffOrderCard.status === 'new'"
        [class.ots-staff-chip--preparing]="staffOrderCard.status === 'preparing'"
        [class.ots-staff-chip--ready]="staffOrderCard.status === 'ready'"
        [class.ots-staff-chip--done]="staffOrderCard.status === 'done'"
        [class.c-bg-blue-500]="staffOrderCard.status === 'new'"
        [class.c-t-gray-100]="staffOrderCard.status === 'new' || staffOrderCard.status === 'preparing' || staffOrderCard.status === 'ready'"
        [class.c-bg-ok-400]="staffOrderCard.status === 'ready'"
        [class.c-bg-gray-300]="staffOrderCard.status === 'done'"
        [class.c-t-gray-600]="staffOrderCard.status === 'done'"
      >
        <img
          [src]="staffOrderCard.statusIconSrc"
          alt=""
          width="12px"
          height="12px"
        />
        <span class="p3">{{ staffOrderCard.statusLabel }}</span>
      </span>
      <div class="ots-staff-order__identity d-flex flex-direction-column gap-4 full-width">
        <p class="p3 fw-semibold c-t-blue-900">{{ staffOrderCard.numberLabel }}</p>
        <div class="ots-staff-order__meta d-flex align-items-center gap-4">
          <img
            src="/assets/images/ots/staff/clock.svg"
            alt=""
            width="20px"
            height="20px"
          />
          <p class="p3 c-t-blue-900 ots-staff-order__meta-text">{{ staffOrderCard.metaLine }}</p>
        </div>
      </div>
    </div>

    <div class="ots-staff-order__place d-flex align-items-center justify-content-space-between gap-8 p-y-8 p-x-16">
      <div class="ots-staff-order__location d-flex align-items-center gap-8">
        @if (staffOrderCard.fulfillmentId === 'delivery') {
          <img
            [src]="staffOrderCard.locationIconSrc"
            alt=""
            width="23px"
            height="16px"
          />
        } @else {
          <img
            [src]="staffOrderCard.locationIconSrc"
            alt=""
            width="14px"
            height="16px"
          />
        }
        <p class="p3 c-t-blue-900 ots-staff-order__location-text">{{ staffOrderCard.locationLine }}</p>
      </div>
      <span
        class="ots-staff-chip d-inline-flex align-items-center width-fit-content white-space-nowrap p-y-4 p-x-8 c-bg-gray-100"
        [class.ots-staff-chip--pickup]="staffOrderCard.fulfillmentId === 'pickup'"
        [class.ots-staff-chip--delivery]="staffOrderCard.fulfillmentId === 'delivery'"
        [class.c-t-gray-600]="staffOrderCard.fulfillmentId === 'pickup'"
      >
        <span class="p3">{{ staffOrderCard.fulfillmentLabel }}</span>
      </span>
    </div>

    <div class="ots-staff-order__lines d-flex flex-direction-column gap-8">
      @for (line of staffOrderCard.lines; track line.lineKey) {
        @if (line.packageProductLabels.length) {
          <div class="ots-staff-order__package d-flex align-items-start justify-content-space-between gap-8 m-x-8 medium-border-radius">
            <div class="ots-staff-order__package-body d-flex flex-direction-column gap-8">
              <span class="p3 c-t-blue-900">{{ line.label }}</span>
              <ul class="ots-staff-order__package-list p3 c-t-blue-900">
                @for (packageLabel of line.packageProductLabels; track $index) {
                  <li>{{ packageLabel }}</li>
                }
              </ul>
            </div>
            <span class="p3 fw-semibold c-t-blue-900 ots-staff-order__package-price white-space-nowrap">{{ line.amountLabel }}</span>
          </div>
        } @else {
          <div class="ots-staff-order__line d-flex align-items-center justify-content-space-between gap-8 p-x-16">
            <span class="p3 c-t-blue-900">{{ line.label }}</span>
            <span class="p3 c-t-blue-900">{{ line.amountLabel }}</span>
          </div>
        }
      }
    </div>

    <hr class="ots-staff-order__divider full-width" />

    <div class="ots-staff-order__footer d-flex align-items-center p-x-16 full-width">
      @if (staffOrderCard.actionLabel) {
        <button
          type="button"
          class="button button--primary button--no-border ots-staff-order__action full-width p-y-8 p-x-32 fw-medium white-space-nowrap"
          [disabled]="staffOrderCard.isMoving"
          (click)="advanceOrderStatus()"
        >
          {{ staffOrderCard.actionLabel }}
        </button>
      } @else {
        <div class="ots-staff-order__completed d-flex align-items-center gap-4">
          <img
            src="/assets/images/ots/staff/completed.svg"
            alt=""
            width="12px"
            height="12px"
          />
          <span class="p3">{{ 'Completed' | trans:'ots.staff.completed' }}</span>
        </div>
      }
    </div>
  </article>
}
